export default {
  sizes: {
    lg: {
      fontSize: '16px',
      px: '26px',
    },
  },
}
